import React from "react";
import HeroSection from "assets/images/aboutUsHome.png";

const Hero = () => {
  return (
    <div className="bg-white w-full py-16 flex items-center justify-center flex-col gap-20">
      <div className="flex flex-col items-center justify-center gap-10 md:px-12 px-4">
        <h1 className="font-bold text-5xl text-bblack-5 lg:w-[23ch] text-center">
          Powering Profitable Capital Deployment to Solve Africa’s 52 Million
          Housing Deficit
        </h1>
        <img
          src={HeroSection}
          alt="Hero Section"
          className="lg:w-[1234px] w-full object-contain lg:h-[540px] h-auto "
        />
      </div>
      <div className="flex justify-center items-center w-full py-6 px-5 md:px-12 md:py-12  bg-ashShade-17">
        <div className="xl:w-[1234px] flex lg:flex-row flex-col items-start justify-start lg:justify-between gap-7 lg:gap-0">
          <h2 className="lg:w-[22ch] text-left text-bblack-5 font-bold text-4xl ">
            Powering Smarter and Safer Capital Deployment for Africa’s Housing
            and Infrastructure.
          </h2>
          <div className="text-bblack-6 xl:w-[47.9ch] lg:w-[30ch] w-full font-medium md:text-lg text-base flex flex-col gap-6">
            <p>
              Africa has a housing deficit estimated at 52 million units. As the
              youngest continent with 60% of its population under 25 years, and
              the fastest urbanizing region with a 3.5% rate over the last 20
              years, Africa is faced with a worsening housing shortage, as well
              as a massive opportunity to attract capital to build out its
              housing and infrastructure needs.
            </p>
            <p>
              At bankolé, we recognize that one of the major barriers to
              deploying capital in property development in Africa is the high
              risk associated with project delivery in the region. {" "}
            </p>
            <p>
              Our mission is to power smart and profitable deployment of capital
              to build out Africa’s housing and infrastructure deficit. We
              deliver on this mission by using cutting-edge digital technology
              to de-risk projects, enabling us to facilitate more profitable
              deployment of capital to project financing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
